/* @flow */
import getPropClasses from 'lib/getPropClasses';
import React from 'react';

import cx from 'classnames';
import './styles/Container.scss';

const propsToClasses = {
  size: {
    large: 'Container-large',
    medium: 'Container-medium',
    small: 'Container-small',
    xsmall: 'Container-xsmall',
    xxsmall: 'Container-xxsmall',
  },
  full: 'Container-full',
};

class Container extends React.Component {
  static propTypes = {
    size: React.PropTypes.oneOf(['xxsmall', 'xsmall', 'small', 'medium', 'large']),
    full: React.PropTypes.bool,
  };

  render() {
    return (
      <div className={cx('Container', getPropClasses(this.props, propsToClasses), this.props.className)}>
        {this.props.children}
      </div>
    );
  }
}

export default Container;



// WEBPACK FOOTER //
// ./src/components/Container.jsx